<div class="row">
  <div class="col">
    <h5 class="title" [ngClass]="{'required': isRequired}">{{getLabel()}}</h5>
    <app-audioplayer *ngIf="formItem?.item?.allowAudio && formItem?.item?.audioFileName != '' && formItem.item?.audioFileName != null" [formItem]="formItem" [formId]="formId"></app-audioplayer>
  </div>
</div>

<div class="row">
  <div class="input col-md-12 col-sm-12 col-xs-12" [class.has-danger]="invalidForm">
    <div class="textbox-area" *ngIf="formItem.item.isMultiplelines; else input">
      <textarea class="form-control" [class.form-control-danger]="validationForm?.invalid"
        [required]="isRequired" [(ngModel)]="formItem.value" #validationForm="ngModel"></textarea>
      <div *ngIf="validationForm.invalid">
        <small *ngIf="validationForm.errors.required">
          This field is required.
        </small>
      </div>
    </div>
    <ng-template #input>
      <input class="form-control csc-label" [class.form-control-danger]="invalidForm"
        type="numeric" [type]="formItem.item.isNumeric ? 'number' : 'text'" [required]="isRequired" [(ngModel)]="formItem.value"
        #validationForm="ngModel">
      <div *ngIf="validationForm.invalid">
        <small *ngIf="validationForm.errors.required" class="incorrect-field">
          This field is required.
        </small>
      </div>
    </ng-template>
  </div>
</div>
